import normalStatuses from 'http-status'

const allStatuses = {}
for (let key of Object.keys(normalStatuses)) {
  if (key.indexOf('_') >= 0) continue
  allStatuses[key] = {
    name: normalStatuses[key],
    code: normalStatuses[key + '_NAME'],
    message: normalStatuses[key + '_MESSAGE']
  }
}
for (let key of Object.keys(normalStatuses.extra.nginx)) {
  if (key.indexOf('_') >= 0) continue
  allStatuses[key] = {
    name: normalStatuses.extra.nginx[key],
    code: normalStatuses.extra.nginx[key + '_NAME'],
    message: normalStatuses.extra.nginx[key + '_MESSAGE']
  }
}
for (let key of Object.keys(normalStatuses.extra.cloudflare)) {
  if (key.indexOf('_') >= 0) continue
  allStatuses[key] = {
    name: normalStatuses.extra.cloudflare[key],
    code: normalStatuses.extra.cloudflare[key + '_NAME'],
    message: normalStatuses.extra.cloudflare[key + '_MESSAGE']
  }
}
allStatuses[502].code = 'BAD_GATEWAY'
allStatuses[502].message = 'The server was acting as a gateway or proxy and received an invalid response from the upstream server.'

export default allStatuses